export const messages = {
  headerLogo: {
    id: 'headerLogo.Alt',
    defaultMessage: 'Logo for ',
  },
  navigation: {
    hamburgerBar: {
      id: 'patientPortal.Navigation.HamburgerBar',
      defaultMessage: '',
    },
    toggleMenu: {
      id: 'patientPortal.Navigation.ToggleMenu',
      defaultMessage: 'Toggle Navigation',
    },
    resources: {
      id: 'patientPortal.Navigation.Resources',
      defaultMessage: 'Resources',
    },
  },
  screenReader: {
    helpLink: {
      id: 'screenReader.HelpLink',
      defaultMessage: 'Help link clicking opens a new window',
    },
    contactUsLink: {
      id: 'screenReader.ContactUsLink',
      defaultMessage: 'Contact us link clicking takes you to contact us page',
    },
  },
  displayNameFormat: {
    id: 'displayNameFormat',
    defaultMessage: '-def- {0} {1}',
  },
};
